import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AppContext = createContext(null);

export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  const hydrateWallet = useCallback(async (p) => {
    if (p && p.role !== "admin") {
      try {
        const w = await api.getWallet(p.id);
        setWallet(w);
      } catch {
        setWallet(null);
      }
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("dondrae_token");
    if (token) {
      api
        .me()
        .then(async (p) => {
          setProfile(p);
          await hydrateWallet(p);
        })
        .catch(() => {
          localStorage.removeItem("dondrae_token");
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [hydrateWallet]);

  const register = async (data) => {
    const res = await api.register(data);
    localStorage.setItem("dondrae_token", res.token);
    setProfile(res.profile);
    await hydrateWallet(res.profile);
    return res.profile;
  };

  const login = async (email, password) => {
    const res = await api.login(email, password);
    localStorage.setItem("dondrae_token", res.token);
    setProfile(res.profile);
    await hydrateWallet(res.profile);
    return res.profile;
  };

  const refreshWallet = useCallback(async () => {
    if (!profile) return;
    try {
      const w = await api.getWallet(profile.id);
      setWallet(w);
    } catch { /* ignore */ }
  }, [profile]);

  const logout = () => {
    localStorage.removeItem("dondrae_token");
    setProfile(null);
    setWallet(null);
  };

  return (
    <AppContext.Provider value={{ profile, wallet, loading, register, login, refreshWallet, logout, setWallet }}>
      {children}
    </AppContext.Provider>
  );
}
